/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEpisodeInfo,
    JsonEpisodeInfoFromJSON,
    JsonEpisodeInfoFromJSONTyped,
    JsonEpisodeInfoToJSON,
} from './JsonEpisodeInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEpisodeInfo
 */
export interface ApiResultOfListOfJsonEpisodeInfo {
    /**
     * 
     * @type {Array<JsonEpisodeInfo>}
     * @memberof ApiResultOfListOfJsonEpisodeInfo
     */
    data?: Array<JsonEpisodeInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEpisodeInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEpisodeInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEpisodeInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEpisodeInfo
     */
    result?: ApiResultOfListOfJsonEpisodeInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEpisodeInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEpisodeInfoFromJSON(json: any): ApiResultOfListOfJsonEpisodeInfo {
    return ApiResultOfListOfJsonEpisodeInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEpisodeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEpisodeInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEpisodeInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEpisodeInfoToJSON(value?: ApiResultOfListOfJsonEpisodeInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEpisodeInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

